import React from 'react';

const Overview = ({ nextStep, formData, updateFormData }) => {
  const handleCompanyNameChange = (e) => {
    updateFormData && updateFormData('companyName', e.target.value);
  };

  const handleContactNameChange = (e) => {
    updateFormData && updateFormData('contactName', e.target.value);
  };

  const handleContactEmailChange = (e) => {
    updateFormData && updateFormData('contactEmail', e.target.value);
  };

  return (
    <div className="container">
      <div className="header">
        <h2>Technology Due Diligence Assessment</h2>
      </div>
      <p>
        Welcome to the Technology Due Diligence assessment platform. This tool is designed to help gather critical information about your technology organization, infrastructure, and practices to support the due diligence process.
      </p>
      <p>
        You will be asked to answer five key questions about your technology organization. For each question, you can provide a detailed text response and attach relevant documents if needed.
      </p>
      <p>
        The information you provide will be securely stored and only accessible to the authorized due diligence team. Your responses will help us understand your technology landscape and identify areas for further discussion.
      </p>

      {updateFormData && (
        <div className="form-section">
          <h3>Company Information</h3>
          <div className="form-group">
            <label htmlFor="companyName">Company Name:</label>
            <input
              type="text"
              id="companyName"
              value={formData.companyName}
              onChange={handleCompanyNameChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="contactName">Contact Name:</label>
            <input
              type="text"
              id="contactName"
              value={formData.contactName}
              onChange={handleContactNameChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="contactEmail">Contact Email:</label>
            <input
              type="email"
              id="contactEmail"
              value={formData.contactEmail}
              onChange={handleContactEmailChange}
              required
            />
          </div>
          <button 
            onClick={nextStep}
            disabled={!formData.companyName || !formData.contactName || !formData.contactEmail}
            className="next-button"
          >
            Begin Assessment
          </button>
        </div>
      )}

      {!updateFormData && (
        <div className="blurred-content">
          <p>Please enter your invite code to access the assessment.</p>
        </div>
      )}
    </div>
  );
};

export default Overview;
